/**
 * Single source of truth for whether a geocoded location is BUILDING/STREET-exact
 * or only an APPROXIMATE area anchor. Used by the map (exact = solid pin, approximate
 * = muted circle) and by the `approxLocation` SERP lens (which surfaces the
 * not-yet-precise offers). Pure + testable (see geocodePrecision.test.ts).
 *
 * Exact providers resolve an actual point for THIS flat:
 *  - `nominatim`     — a street/house-number geocode
 *  - `portal:coords` — the landlord's own portal-listing coordinates
 *  - `owner_address` — the owner geocoded their exact address in the add-property
 *                      wizard (multi-origin supply: owner manual rows in the SERP)
 * Everything else that carries coords is an area approximation (a centroid, a
 * transit-landmark multilateration, a named-feature point) and must NEVER render
 * as an exact pin — that would be a false-positive precise location.
 */
/**
 * LISTA WYKLUCZAJĄCA JEST JEDYNA — i to jest decyzja, nie wygoda.
 *
 * Wszystko, czego tu nie ma, jest przybliżone. Nowy dostawca geokodowania staje się więc
 * przybliżony SAM Z SIEBIE, dopóki ktoś świadomie go tu nie dopisze — a to jest bezpieczna
 * strona pomyłki: pokazanie przybliżonej lokalizacji jako dokładnej to fałszywy adres
 * mieszkania, odwrotnie to tylko ostrożność.
 *
 * Istniała obok tego lista WYLICZAJĄCA dostawców przybliżonych. Skasowana 2026-09-26:
 * nie miała ani jednego czytelnika poza własnym testem, jej docstring twierdził coś
 * przeciwnego niż wdrożone zachowanie soczewki „bez dokładnej lokalizacji", i — co
 * rozstrzygnęło — brakowało w niej `portal:address`, czyli 371 aktywnych ofert. Gdyby ją
 * kiedykolwiek podpięto, te oferty po cichu trafiłyby do złego kubełka. Lista wykluczająca
 * takiego trybu awarii nie ma.
 */
export const EXACT_GEOCODE_PROVIDERS: ReadonlySet<string> = new Set([
  'nominatim',
  'portal:coords',
  'owner_address',
]);

/** True when a pin should be drawn as approximate (muted circle), not an exact marker. */
export function isApproximateGeocode(
  provider: string | null | undefined,
  hasCoords: boolean,
): boolean {
  if (!hasCoords) return true; // no point at all → district-centroid fallback
  if (!provider) return false; // legacy precise row (coords + no provider) → treat as exact
  return !EXACT_GEOCODE_PROVIDERS.has(provider);
}
